import React from 'react';
import '../../assets/Style.css'; // adjust the path as needed
import Group from "../../assets/images/Group 409.png"
import { Link } from 'react-router-dom';

const Service = () => {
    return (
        <section>
            <div className="service">


                <img src={Group} alt="Service Illustration" className="service-image" />

                <div className="service-button">
                    <Link to={'/creativity'} className="service-btn1"> About Creativity</Link>
                    <Link to={"/logics"} className="service-btn1"> About Logics
                    </Link >
                    <Link to={"/leads"} className="service-btn1">
                        About Leads</Link>

                </div>
            </div>
        </section>
    );
};

export default Service;
